import React, { useState, useEffect, useRef } from "react";
import { formInputErrorMsg } from "./empConstants";

function EMPSimpleSelect(props) {
  const {
    label,
    name,
    id,
    fieldId,
    isRequired,
    errId,
    divClass,
    options,
    fieldName,
    fieldValue,
    handleSelectChange,
    checkDetailsIndex,
    hasError = null,
    isDisabled
  } = props;

  const [fieldVal, setFieldVal] = useState('');

  const handleOnChange = (e) => {
    handleSelectChange(e.target);
    setFieldVal('');
  };

  useEffect(() => {
    if(fieldName == 'reason_for_leaving' && options){
      let flag = false;
      Object.values(options).map((option) => {
        if(option.reason == fieldValue){
          flag = true;
        }
      })
          
      if(!flag && fieldValue){
        setFieldVal(fieldValue);
      }
    } else if(fieldName == 'company_location' && options){
      let flag = false;
      options?.map(option => {
        if(option?.OFFICE_NAME == fieldValue){
          flag = true;
        }
      })
          
      // if(!flag && fieldValue){
        setFieldVal(fieldValue);
      // }
    }
  },[fieldValue])

  const errorMsg =
    (fieldValue == null || fieldValue == "") && isRequired == 1
      ? formInputErrorMsg.requiredError
      : formInputErrorMsg.InvalidError;

  return (
    <>
      <div className="col-sm-4 col-md-12 col-xl-4">
        <div className="form-group">
          <div className="floating-label tp-dropdown">
            <select
              name={name}
              id={id}
              className="form-control"
              onChange={(e) => handleOnChange(e)}
              data-checkdetailsindex={checkDetailsIndex}
              data-fieldname={fieldName}
              // ref={inputText}
              value={fieldValue || fieldVal}
              disabled={isDisabled || false}
            >
              <option value="" disabled selected = {!fieldValue || !Object.keys(options || {})?.length}>Select Option</option>
              {fieldName == "location"
                ? options.map((option) => {
                    return (
                      <option
                        value={option.label}
                        selected={fieldValue == option.label ? true : false}
                      >
                        {option.label}
                      </option>
                    );
                  })
                : 
                fieldName === 'reason_for_leaving'
                ? <>
                
                 { Object.values(options).map((option, index) => (
                    <option
                    key={index}
                    value={option.reason || fieldVal}
                    // selected={ fieldValue == option.reason ? true : false}
                    >
                      {option.reason}
                    </option>
                  ))
                   
                } 
                {fieldVal && !Object.values(options).some(option => option.reason === fieldVal) && (
                <option value={fieldVal}>
                  {fieldVal}
                </option>
              )}
              </>
                   
                : fieldName == "company_location" 
                ? <>
                
                {options?.map((option, index) => (
                   <option
                   key={index}
                   value={option.OFFICE_NAME || fieldVal}
                   // selected={ fieldValue == option.reason ? true : false}
                   >
                     {option.OFFICE_NAME}
                   </option>
                 ))
                  
               } 
               {fieldVal && !options.some(option => option.OFFICE_NAME === fieldVal) && (
               <option value={fieldVal}>
                 {fieldVal}
               </option>
             )}
             </>
                :
                 Object.entries(options).map((option) => {
                    return (
                      <option
                        value={option[1]}
                        selected={fieldValue == option[1] ? true : false}
                      >
                        {option[1]}
                      </option>
                    );
                  })}
            </select>
            <label htmlFor={id} className={"focused"}>
              {label}
              {isRequired == 1 && <sup className="text-danger">*</sup>}
            </label>
          </div>
          {hasError && hasError === true && (
            <p className="err text-danger" id={errId}>
              {errorMsg}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default EMPSimpleSelect;